/* Blanditos · Buscador predictivo del header (sugerencias mientras escribes) */
(function () {
  'use strict';
  var forms = document.querySelectorAll('form[data-bl-psearch]');
  if (!forms.length) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function hl(text, q) {
    var t = String(text || ''), n = norm(t), words = norm(q).split(/\s+/).filter(Boolean), marks = [];
    words.forEach(function (w) { var i = n.indexOf(w); if (i > -1) marks.push([i, i + w.length]); });
    if (!marks.length) return esc(t);
    marks.sort(function (a, b) { return a[0] - b[0]; });
    var out = '', pos = 0;
    marks.forEach(function (m) { if (m[0] < pos) return; out += esc(t.slice(pos, m[0])) + '<mark>' + esc(t.slice(m[0], m[1])) + '</mark>'; pos = m[1]; });
    return out + esc(t.slice(pos));
  }
  function money(v, fmt) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    var amt = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt ? fmt.replace(/\{\{\s*\w+\s*\}\}/, amt).replace(/<[^>]*>/g, '') : 'S/ ' + amt;
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  forms.forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var wrap = form.parentElement;
    var fmt = wrap.getAttribute('data-money') || '';
    var uid = 'blps-' + Math.random().toString(36).slice(2, 7);
    var panel = document.createElement('div');
    panel.className = 'bl-psearch';
    panel.id = uid;
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    wrap.classList.add('bl-psearch-host');
    wrap.appendChild(panel);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', uid);
    input.setAttribute('aria-expanded', 'false');

    var timer, ctrl, active = -1, lastQ = '';

    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); wrap.classList.add('is-open'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); wrap.classList.remove('is-open'); active = -1; }
    function items() { return Array.prototype.slice.call(panel.querySelectorAll('[data-ps-item]')); }
    function setActive(i) {
      var list = items(); if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function (el, k) { el.classList.toggle('is-active', k === active); el.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      list[active].scrollIntoView({ block: 'nearest' });
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], cols = r.collections || [], queries = r.queries || [], pages = r.pages || [];
      var all = root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var h = '';
      if (queries.length) {
        h += '<div class="bl-psearch__chips">';
        queries.slice(0, 4).forEach(function (s) { h += '<a data-ps-item class="bl-psearch__chip" href="' + esc(s.url) + '">' + (s.styled_text || esc(s.text)) + '</a>'; });
        h += '</div>';
      }
      if (products.length) {
        h += '<p class="bl-psearch__label">Productos</p><ul class="bl-psearch__list">';
        products.forEach(function (p) {
          var cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price);
          h += '<li><a data-ps-item class="bl-psearch__prod" href="' + esc(p.url) + '">' +
            '<span class="bl-psearch__img">' + (p.image ? '<img src="' + esc(img(p.image, 120)) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
            '<span class="bl-psearch__info"><span class="bl-psearch__title">' + hl(p.title, q) + '</span>' +
            '<span class="bl-psearch__price">' + (cmp ? '<s>' + esc(money(p.compare_at_price_max, fmt)) + '</s> ' : '') + esc(money(p.price, fmt)) +
            (p.available === false ? ' <em>Agotado</em>' : '') + '</span></span></a></li>';
        });
        h += '</ul>';
      }
      if (cols.length || pages.length) {
        h += '<p class="bl-psearch__label">Colecciones y páginas</p><div class="bl-psearch__chips">';
        cols.slice(0, 4).forEach(function (c) { h += '<a data-ps-item class="bl-psearch__chip bl-psearch__chip--col" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; });
        pages.slice(0, 3).forEach(function (c) { h += '<a data-ps-item class="bl-psearch__chip bl-psearch__chip--col" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>'; });
        h += '</div>';
      }
      if (!products.length && !cols.length && !pages.length) {
        h += '<p class="bl-psearch__empty">No encontramos nada con <strong>“' + esc(q) + '”</strong>. Prueba con otro modelo, color o talla.</p>';
      }
      h += '<a data-ps-item class="bl-psearch__all" href="' + all + '">Ver todos los resultados de “' + esc(q) + '” <span aria-hidden="true">→</span></a>';
      panel.innerHTML = h;
      active = -1;
      open();
    }

    function search(q) {
      if (cache[q]) { render(cache[q], q); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      wrap.classList.add('is-loading');
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor';
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) { cache[q] = d; if (q === lastQ) render(d, q); })
        .catch(function () {})
        .then(function () { wrap.classList.remove('is-loading'); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () { search(q); }, 220);
    });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && panel.innerHTML) open(); });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  });
})();
